__webpack_require__.p = "/toggleSwitch/";